module.exports = __webpack_public_path__ + "img/escultura-naranco-transversal-muestreo.89aac3cf.png";